import React from "react";
import "../css/privacy.scss";

function Cookies() {
  return (
    <main className="layout--template" id="main_content">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title"><h1>Cookie Policy</h1></div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p><strong>Last updated: September 14, 2026</strong></p>
            <p><strong>What cookies are</strong><br />Cookies are small text files stored by your browser. Similar technologies include local storage, pixels, and device identifiers. They help a website remember information and understand how it is used.</p>
            <p><strong>Essential technologies</strong><br />These support core functions such as navigation, security, checkout, and remembering the contents of your cart. The current site stores cart information in your browser's local storage so it remains available between visits.</p>
            <p><strong>Preference technologies</strong><br />These may remember choices such as language or display settings when those features are available.</p>
            <p><strong>Analytics technologies</strong><br />If enabled, these help us understand aggregated site traffic, page performance, and errors so we can improve the experience.</p>
            <p><strong>Advertising technologies</strong><br />If enabled, these may measure campaigns or help limit and personalize advertising. Tugglefield does not activate non-essential advertising technologies without any consent required by applicable law.</p>
            <p><strong>Your choices</strong><br />You can delete or block cookies and site storage in your browser settings. Blocking essential storage may prevent the cart or checkout from working as expected. Where a cookie preference control is presented, you can use it to update non-essential choices.</p>
            <p><strong>Changes and contact</strong><br />We may update this policy when our technologies or legal obligations change. Questions can be sent to <a href="mailto:steps@tugglefield.xyz">steps@tugglefield.xyz</a>.</p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Cookies;
